import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaFilterButtonComponent } from './la-filter-button.component';
import { LaIconModule } from '../icon/la-icon.module';
import { LaTextModule } from '../text/la-text.module';
import { LaCheckboxGroupComponent } from '../checkbox-group/la-checkbox-group.component';
import { LaRadioGroupComponent } from '../radio-group/la-radio-group.component';

export { LaIconModule } from '../icon/la-icon.module';
export { LaTextModule } from '../text/la-text.module';

@NgModule({
  imports: [
    CommonModule,
    LaIconModule.forRoot(),
    LaTextModule.forRoot()
  ],
  declarations: [
    LaFilterButtonComponent,
    LaCheckboxGroupComponent,
    LaRadioGroupComponent
  ],
  exports: [
    LaFilterButtonComponent,
    LaCheckboxGroupComponent,
    LaRadioGroupComponent,
    LaIconModule,
    LaTextModule
  ]
})
export class LaFilterButtonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaFilterButtonModule,
      providers: []
    }
  }
}
